import { render, staticRenderFns } from "./OffPayRate.vue?vue&type=template&id=63b8eba8&scoped=true&"
import script from "./OffPayRate.vue?vue&type=script&lang=js&"
export * from "./OffPayRate.vue?vue&type=script&lang=js&"
import style0 from "./OffPayRate.vue?vue&type=style&index=0&id=63b8eba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b8eba8",
  null
  
)

export default component.exports